import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './services/auth.service';
import { AppConstants } from './constants/app-constants';

@Injectable()
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  async canActivate(next: ActivatedRouteSnapshot): Promise<boolean> {
    const user = this.authService.getUser();
    const allowedRoles = (next.data['roles'] as string[] || AppConstants.ADMIN_ROLES)
      .map(role => String(role).trim().toLowerCase());

    if (!user) {
      this.router.navigate(['/']);
      return false;
    }

    const roleName = String(user.role?.name || user.role || '').trim().toLowerCase();
    const isAdminRoute = allowedRoles.some(role => AppConstants.ADMIN_ROLES.includes(role));
    const isSupervisorRoute = allowedRoles.includes(AppConstants.SUPERVISOR_ROLE);
    const isTeacherRoute = allowedRoles.includes(AppConstants.TEACHER_ROLE);

    if ((isAdminRoute && this.authService.isAdmin())
      || (isSupervisorRoute && this.authService.isSupervisor())
      || (isTeacherRoute && this.authService.isTeacher())
      || allowedRoles.includes(roleName)) {
      return true;
    }

    if (this.authService.isTeacher()) {
      this.router.navigate(['/teacher']);
    } else if (this.authService.isSupervisor()) {
      this.router.navigate(['/supervisor']);
    } else if (this.authService.isAdmin()) {
      this.router.navigate(['/main']);
    } else {
      this.router.navigate(['/']);
    }
    return false;
  }
}
